import { InjectionToken } from '@angular/core';

export const CARDNET_ENV = new InjectionToken<string>('CARDNET_ENV');

export const CARDNET_FORM_ID = new InjectionToken<string>('CARDNET_FORM_ID');

export const CARDNET_KEY = new InjectionToken<string>('CARDNET_KEY');
